angular.module('aprima-utils').directive('apGoogleMaps',
    ['$window', '_', '$sce',
        function ($window, _, $sce) {
            'use strict';

//           Google's documentation for embedding Google Maps (May 28, 2015):
//           https://developers.google.com/maps/documentation/embed/guide

            //Api Key given by Google (browser only)
            //var apiKey = 'AIzaSyDtvKhyJ1Qtc1PWYX1lOQcJi2Q8earxj6M'; //Karl's Key
            var apiKey = 'AIzaSyDc0BvZWljbSm5cdoKh6D6ZypnJ9ARYkbA'; //Aprima's key (browser)

            //var types=['place', 'directions', 'search', 'view', 'streetview'];

            function combine(array) {
                return  _(array).compact().map(encodeURIComponent).value().join('+');
            }

            function iFrameSettings(scope) {
                var result = '<iframe width="';
                    result += (scope.width ? scope.width : '100%') + '" height="';
                    result += (scope.height ? scope.height : '280') +'" frameborder="';
                    result += (scope.frameBorder ? scope.frameBorder : '0') + '" style="';
                    result += (scope.style ? scope.style : 'border:0') + '" src="';
                return result;
            }

            function makeIFrame(scope, element) {
                var iframe= ''+iFrameSettings(scope);
                if(!scope.type || scope.type==='place') {
                    iframe += makePlaceURL(scope.name, scope.address, scope.city, scope.state, scope.zip);
                }
                else if(scope.type==='directions'){
                    iframe += makeDirectionURL(
                        scope.originname, scope.originaddress, scope.origincity, scope.originstate, scope.originzip,
                        scope.name, scope.address, scope.city, scope.state, scope.zip);
                }
                iframe+='"></iframe>';
                element[0].innerHTML=iframe;
            }

            function link(scope, element) {
                makeIFrame(scope,element);

                var watchGroup = scope.$watchGroup(
                    ['name', 'address', 'city', 'state', 'zip',
                    'width', 'height', 'frameborder', 'style', 'type',
                    'originname', 'originaddress', 'origincity', 'originstate', 'originzip'], function() {
                    makeIFrame(scope, element);
                });

                scope.$on('destroy', function () {
                    watchGroup();
                });
            }

            function makePlaceURL(name,address,city,state,zip) {
                var url = 'https://www.google.com/maps/embed/v1/place?key='+apiKey+'&q=';
                url += _.isString(address) ?
                    combine([name,address,city,state,zip]) :
                    combine([name,address.Address1,address.City,address.State,address.Zip]);
                url=$sce.trustAsResourceUrl(url);
                return url;
            }

            function makeDirectionURL(originName,originAddress,originCity,originState,originZip, name,address,city,state,zip) {
                var url = 'https://www.google.com/maps/embed/v1/place?key='+apiKey+'&origin=';
                url += _.isString(originAddress) ?
                    combine([originName,originAddress,originCity,originState,originZip]) :
                    combine([originName,originAddress.Address1,originAddress.City,originAddress.State,originAddress.Zip]);
                url += '&destination=';
                url += _.isString(address) ?
                    combine([name,address,city,state,zip]) :
                    combine([name,address.Address1,address.City,address.State,address.Zip]);
                url=$sce.trustAsResourceUrl(url);
                return url;
            }

            return {
                restrict: 'EA',
                scope: {
                    width: '=width',
                    height: '=height',
                    frameborder: '=frameborder',
                    style: '=style',
                    type: '=type',
                    name: '=name',
                    address: '=address',
                    city: '=city',
                    state: '=state',
                    zip: '=zip',
                    originname: '=originname',
                    originaddress: '=originaddress',
                    origincity: '=origincity',
                    originstate: '=originstate',
                    originzip: '=originzip'
                },
                link: link
            };
        }]);